(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-details-block1"] && !Shopify.designMode) return;
  try {
    

  $(".pd_nav a[href^='#']").click(function(e) {
	e.preventDefault();
	var position = $($(this).attr("href")).offset().top;
	$("body, html").animate({
		scrollTop: position
	} /* speed */ );
  });
  jQuery(document).ready(function($) {
    var distance = $('.pd_nav').offset().top - 160;
    $window = $(window);
    $window.scroll(function() {
      if ( $window.scrollTop() > distance ) {
        $('.pd_nav').addClass("nav_fixed");
      }
      else {
        $('.pd_nav').removeClass("nav_fixed");
      }
    });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-block3"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('#d_selectbox').on('change', function(){
    	var demovalue = $(this).val(); 
        $("div.dream-pip-dimensions-tab").hide();
        $("#dimensions-tab_"+demovalue).show();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sectional-configurations"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.dataset.scReady === 'true') return;
    root.dataset.scReady = 'true';

    var tabs = root.querySelectorAll('[data-sc-tab]');
    var stages = root.querySelectorAll('[data-sc-stage]');

    function activate(index) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-config-index') === String(index);
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      stages.forEach(function (stage) {
        var active = stage.getAttribute('data-config-index') === String(index);
        stage.classList.toggle('is-active', active);
        if (active) {
          stage.removeAttribute('hidden');
        } else {
          stage.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-config-index'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('.sc-configs').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.sc-configs')
      : null;
    if (section) {
      section.dataset.scReady = 'false';
      initSection(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
